var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9654 23.9583C13.753 24.3246 13.4481 24.6285 13.0812 24.8398C12.7143 25.0512 12.2984 25.1624 11.875 25.1624C11.4516 25.1624 11.0357 25.0512 10.6688 24.8398C10.3019 24.6285 9.99702 24.3246 9.78458 23.9583M19.125 8.25C19.125 6.32718 18.3612 4.48311 17.0015 3.12348C15.6419 1.76384 13.7978 1 11.875 1C9.95218 1 8.10812 1.76384 6.74848 3.12348C5.38884 4.48311 4.625 6.32718 4.625 8.25C4.625 16.7083 1 19.125 1 19.125H22.75C22.75 19.125 19.125 16.7083 19.125 8.25Z",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.9008f4d1775abb31562ec0363388108c.svg";
export { ForwardRef as ReactComponent };